export function home(prefix: string) {
  return {
    DASHBOARD: `${prefix}`,
    PROFILE: `${prefix}profile`,
  };
}
